import { CatsRecordTypeEnum } from '@shared-enums/cats.enum';

import { ITableConfigEntity } from '../interfaces/internal-interfaces';
import { CatsRecord } from '../scripts/catsRecord';
import { Equipment } from './equipment';
import { getConfigByKey } from './table-configs/table-config-helpers';

export class EquipmentCatsRecord extends CatsRecord {
  constructor(
    public readonly equipment: Equipment,
    config: ITableConfigEntity[],
  ) {
    super('eqp');
    this.__config = config;
    this.__RecOrderChanged$.subscribe({
      next: (number) => {
        //also fires when the record is initialized.
        this.fetchBillcodes(number);
      },
      error: (err) => {
        console.error('Error occurred while updating RecOrder:', err);
      },
    });
  }

  public getRequiredObject(equipment: Equipment): this {
    this.Zmatnr = '';
    this.Employeenumber = equipment.getPlaceholderEmployee();
    this.Zequipment = equipment.EquipmentId;
    this.Catshours = 0;
    this.Acttype = equipment.Type;
    this.Workdate = equipment.focusedDay?.unix ?? null; //get the moment object for the focused day, convert it to odata friendly value.
    this.RecOrder = '';
    this.ZempCreatedBy = equipment.datahub.user.getEmpId();
    this.SendCctr = equipment.CostCenter;
    this.Zrecordtype = CatsRecordTypeEnum.Equipment;
    return this;
  }

  private fetchBillcodes(serviceOrder: string): void {
    getConfigByKey(this.__config, 'Zmatnr').selectOptions = this.equipment.datahub.contracts
      .findContractByServiceOrder(serviceOrder)
      .getEquipmentBillCodes();
    if (!this.Zmatnr && this.__isNew) {
      this.Zmatnr = this.equipment.datahub.contracts.findContractByServiceOrder(serviceOrder).getEquipmentDefault(this.equipment);
    }
  }
}
